import { render, staticRenderFns } from "./foodOrderList.vue?vue&type=template&id=7c7629ec&scoped=true"
import script from "./foodOrderList.vue?vue&type=script&lang=js"
export * from "./foodOrderList.vue?vue&type=script&lang=js"
import style0 from "./foodOrderList.vue?vue&type=style&index=0&id=7c7629ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7629ec",
  null
  
)

export default component.exports